import { Box, Divider } from "@mui/material";
import { MonthFilter } from "../../publicPackages2/filter/MonthFilter";
import { FilterSideMenu } from "./FilterSideMenu";
import TagFiltersMenu from "./TagFiltersMenu";

export function ECommerceFilter() {
  return (
    <FilterSideMenu>
      <Divider />
      <Box
        sx={{
          flexBasis: "20%",
        }}
      >
        <MonthFilter />
      </Box>
      <Divider />
      <TagFiltersMenu />
    </FilterSideMenu>
  );
}
